module.exports = __webpack_public_path__ + "img/c08_unitgadawarrior_Normal_ua.1499322e.webp";